import React, { createContext, useState, useContext, useEffect } from 'react';
import { apiCall } from '../services/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  // Mock user for testing - bypass authentication
  const [user, setUser] = useState({ username: 'testuser', token: 'mock-token' });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Mock authentication - skip API calls
    setLoading(false);
  }, []);

  const login = (userData) => {
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('username');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};
